
// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
import FitTextToBounds from "../components/core/FitTextToBounds";
import LocaliseText from "../components/core/LocaliseText";
import BtnAreYouSureTick from "../prefabs/btns/BtnAreYouSureTick";
import BtnAreYouSureCross from "../prefabs/btns/BtnAreYouSureCross";
/* START-USER-IMPORTS */
import UIButton from "../components/core/UIButton";
import GameUI from "./GameUI";
/* END-USER-IMPORTS */

export default class areYouSureMenu extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // menu
    const menu = scene.add.container(0, 0);
    this.add(menu);

    // arm
    const arm = scene.add.image(0, -296, "endscreen", "popup-arm.png");
    menu.add(arm);

    // menuBg
    const menuBg = scene.add.image(0, 0, "endscreen", "popup-pause-box.png");
    menu.add(menuBg);

    // Title
    const title = scene.add.container(1, -155);
    menu.add(title);

    // panelNine_1
    const panelNine_1 = scene.add.image(0, 0, "endscreen", "popup-heading-small.png");
    title.add(panelNine_1);

    // label
    const label = scene.add.text(0, 0, "", {});
    label.setOrigin(0.5, 0.5);
    label.text = "New text";
    label.setStyle({ "fontFamily": "Acme-Regular", "fontSize": "50px", "shadow.offsetY":3,"shadow.fill":true});
    label.setPadding({"left":10,"top":10,"right":10,"bottom":10});
    title.add(label);

    // btnAreYouSureTick
    const btnAreYouSureTick = new BtnAreYouSureTick(scene, 133, 11);
    menu.add(btnAreYouSureTick);

    // btnAreYouSureCross
    const btnAreYouSureCross = new BtnAreYouSureCross(scene, -126, 9);
    menu.add(btnAreYouSureCross);

    // label (components)
    const labelFitTextToBounds = new FitTextToBounds(label);
    labelFitTextToBounds.maxWidth = 450;
    labelFitTextToBounds.constrainByWidth = true;
    const labelLocaliseText = new LocaliseText(label);
    labelLocaliseText.copyId = "areYouSure";

    this.menu = menu;
    this.arm = arm;
    this.menuBg = menuBg;
    this.btnAreYouSureTick = btnAreYouSureTick;
    this.btnAreYouSureCross = btnAreYouSureCross;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private menu: Phaser.GameObjects.Container;
  private arm: Phaser.GameObjects.Image;
  private menuBg: Phaser.GameObjects.Image;
  private btnAreYouSureTick: BtnAreYouSureTick;
  private btnAreYouSureCross: BtnAreYouSureCross;
  public menuStartY: number = -600;
  public menuEndY: number = 0;

  /* START-USER-CODE */

  private closeCallback: (() => void) | undefined;

  public activate(closeCallback?: () => void) {
    this.closeCallback = closeCallback;

    this.transitionIn();
  }

  protected transitionIn() {

    this.btnAreYouSureCross.once(UIButton.events.clicked, this.transitionOut, this);
    // this.btnHome.once(UIButton.events.clicked, this.onHome, this);
    this.btnAreYouSureTick.on(UIButton.events.clicked, this.onHome, this);


    this.menu.y = this.menuStartY;
    this.scene.add.tween({
      targets: this.menu,
      y: { from: this.menuStartY, to: this.menuEndY },
      duration: 500,
      ease: Phaser.Math.Easing.Back.Out,
      delay: 250
    });

  }

  protected beforeExit() {

    this.btnAreYouSureCross.off(UIButton.events.clicked, this.transitionOut, this);
    // this.btnHome.off(UIButton.events.clicked, this.transitionOut, this);
    this.btnAreYouSureTick.off(UIButton.events.clicked, this.onHome, this);

    this.scene.tweens.killTweensOf([this.menu]);
  }

  protected transitionOut() {


    this.beforeExit();

    this.scene.add.tween({
      targets: this.menu,
      y: this.menuStartY,
      duration: 400,
      ease: Phaser.Math.Easing.Back.In
    });


    this.scene.time.delayedCall(400, () => {
      this.closeCallback?.();
    });
  }

  protected onHome() {
    this.beforeExit();

    console.log("Go Home!");

    this.scene.app.AudioHandler.setChannelPause('sfx', false);
    this.scene.app.AudioHandler.setChannelPause('music', false);

    this.scene.events.emit(GameUI.events.Home);
  }

  protected getSFXAudioIsMuted(): boolean {
    return this.scene.app.AudioHandler.getChannelMute('sfx');
  }

  protected getMusicAudioIsMuted(): boolean {
    return this.scene.app.AudioHandler.getChannelMute('music');
  }

  protected toggleSFXAudio() {
    let isMuted = this.getSFXAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('sfx', !isMuted);
  }

  protected toggleMusicAudio() {
    let isMuted = this.getMusicAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('music', !isMuted);

    isMuted = this.getSFXAudioIsMuted();
    this.scene.app.AudioHandler.setChannelMute('sfx', !isMuted);
  }


  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
